import { render, staticRenderFns } from "./UnsupportedMetaData.vue?vue&type=template&id=88d97452&scoped=true&lang=html&"
import script from "./UnsupportedMetaData.vue?vue&type=script&lang=js&"
export * from "./UnsupportedMetaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d97452",
  null
  
)

export default component.exports